import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, firstValueFrom } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private currentLang = new BehaviorSubject<string>('english')
  private translations: any = {} // cache of loaded files

  constructor(private http: HttpClient) {}

  async setLanguage(lang: string) {
    this.currentLang.next(lang)
    if (!this.translations[lang]) {
      // Load from JSON dynamically
      const data = await firstValueFrom(
        this.http.get(`/assets/i18n/${lang}.json`)
      )
      this.translations[lang] = data
    }
    
    // Apply RTL/LTR direction
    this.applyDirection(lang)
  }

  getLanguage() {
    return this.currentLang.value
  }

  isRTL(): boolean {
    return this.currentLang.value === 'arabic'
  }

  getDirection(): string {
    return this.isRTL() ? 'rtl' : 'ltr'
  }

  private applyDirection(lang: string) {
    const isRTL = lang === 'arabic'
    const direction = isRTL ? 'rtl' : 'ltr'
    
    // Apply direction to document
    document.documentElement.setAttribute('dir', direction)
    document.documentElement.setAttribute('lang', lang)
    
    // Add/remove RTL class to body
    if (isRTL) {
      document.body.classList.add('rtl')
      document.body.classList.remove('ltr')
    } else {
      document.body.classList.add('ltr')
      document.body.classList.remove('rtl')
    }
  }

  translate(key: string): string {
    const lang = this.currentLang.value
    return (
      this.translations[lang]?.[key] ||
      this.translations['english']?.[key] || // fallback
      key
    )
  }
}
